import axios from "axios";
import qs from "qs";
import { openLoading } from "store/reducers/tools";
import {
  APP_NAME,
  DELIVERY_KEY,
  FREIGHTWAYS_AUTH,
  FREIGHTWAY_TOKEN,
  SERVER_URL,
} from "utility";

export const authFreightways = async () => {
  const data = qs.stringify({
    grant_type: "client_credentials",
  });
  const config = {
    method: "post",
    url: `${FREIGHTWAYS_AUTH}/oauth2/token`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: FREIGHTWAY_TOKEN,
    },
    data: data,
  };
  return axios(config);
};

export const serviceFreightways = async ({ lat = 0, lon = 0, token = "" }) => {
  const config = {
    method: "get",
    url: `https://cors-anywhere.herokuapp.com/${DELIVERY_KEY}/v1/services?lat=${lat}&lon=${lon}&carrierName=PostHaste`,
    headers: {
      Authorization: token,
      Host: "customer-integration.ep-sandbox.freightways.co.nz",
    },
  };
  return axios(config);
};

export const getLabel = ({ trackingInfo = {}, postCode = "" }) => {
  const token = JSON.parse(localStorage.getItem(APP_NAME))?.auth?.token;
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${SERVER_URL}/api/freightway/label`,
        {
          trackingInfo: trackingInfo ?? {},
          postCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        resolve(fileURL);
        // const file = new Blob([response.data], { type: "application/pdf" });
        // const fileURL = URL.createObjectURL(file);
        // const pdfWindow = window.open();
        // pdfWindow.location.href = fileURL;
      })
      .catch((err) => {
        console.log(err);
        openLoading(false);
        reject(err);
      });
  });
};
